import http from '@/services/http'
import type { Response } from '@/models/api-generated'

const cache: { [table: string]: { [field: string]: Promise<string> } } = {}

export async function apiFormat(table: string | undefined, field: string, value: string) {
	if (table === undefined) table = 'undefined'
	if (!cache[table]) cache[table] = {}

	const key = `${field}__${value}`

	const cached = cache[table][key]
	if (!cached) {
		const pro = async () => {
			const { data } = await http.get<Response<string>>(`api/journal/format/${table}/${field}/${value}`)
			return data.data ?? ''
		}
		cache[table][key] = pro()
	}

	return await cache[table][key]
}
